var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"enter":_vm.enter,"leave":_vm.leave,"after-enter":function($event){_vm.$emit('after-enter')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }